import WebFont from 'webfontloader'

export function useGoogleFonts() {
  const loadFonts = (fonts: string[]) => {
    if (!fonts || fonts.length === 0) return

    return new Promise((resolve, reject) => {
      WebFont.load({
        google: {
          families: fonts,
          display: 'swap',
        },
        active: () => resolve(true),
        inactive: () => reject(new Error('Failed to load fonts')),
      })
    })
  }

  const extractUniqueFonts = (placementSettings: any): string[] => {
    const fonts = new Set<string>()

    // Extract fonts from vehicle detail rows
    placementSettings.vehicleDetailRows?.forEach((row: any) => {
      const fontFamily = row.typography?.fontFamily

      if (fontFamily && !isSystemFont(fontFamily)) {
        const fontFamily = row.typography.fontFamily.split(',')[0].trim()
        if (!isSystemFont(fontFamily)) {
          fonts.add(fontFamily)
        }
      }
    })

    // Extract CTA font if it exists
    if (placementSettings.callToAction?.typography?.fontFamily) {
      const ctaFont = placementSettings.callToAction.typography.fontFamily
        .split(',')[0]
        .trim()
      if (!isSystemFont(ctaFont)) {
        fonts.add(ctaFont)
      }
    }

    return Array.from(fonts)
  }

  const isSystemFont = (font: string): boolean => {
    const systemFonts = [
      'Arial',
      'Helvetica',
      'Times New Roman',
      'Times',
      'Courier New',
      'Courier',
      'Verdana',
      'Georgia',
      'system-ui',
      '-apple-system',
      'inherit',
      'initial',
    ]
    return systemFonts.some(systemFont =>
      font.toLowerCase().includes(systemFont.toLowerCase()),
    )
  }

  return {
    loadFonts,
    extractUniqueFonts,
  }
}
